import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, Input, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { IInput } from '../../molecules/input/input.interface';
import { IAddressLookup } from './input.address.lookup.interface';
import { IErrors } from './../../molecules/input/errors.interface';
import { InputAddressLookUpService } from './input.address.lookup.service';

import { IAlerts } from '../../molecules/alerts/alert/alert.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputAddressLookupSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-address-lookup',
    templateUrl: './input.address.lookup.component.html',
    styleUrls: ['./input.address.lookup.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR,
        InputAddressLookUpService
    ]
})

export class InputAddressLookupSharedComponent implements OnInit {
    inputData: IInput = { icon: 'location-arrow' };
    @Input()
    set input(val: IInput) {
        if (val) {
            this.inputData = val;
            this.inputData.icon = 'location-arrow';
        }
    }

    get input(): IInput {
        return this.inputData;
    }

    @Input() errors: Array<IErrors> = [];
    @Input() country = '';
    @Input('value') _value = '';

    addresses = undefined;
    reverseAddress = '';
    searchTerm$ = new Subject<string>();
    alerts: Array<IAlerts> = [];

    onChange: any = () => {};
    onTouched: any = () => {};

    constructor(
        private InputAddLookUpService: InputAddressLookUpService
    ) {}

    get value(): any { return this._value; }

    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    ngOnInit(): void {
        this.searchTerm$.subscribe(text => {
            this.setAddress({ formatted_address: text });
            if (text === '') this.closeDropDown();
        });

        this.InputAddLookUpService.getAddresses(this.searchTerm$, this.country)
            .subscribe(
                addresses => this.addresses = addresses,
                errors => this.alerts.push({ message: errors.statusText, status: 'danger' })
            );
    }

    registerOnChange(fn): void {
        if (this.value && typeof this.value === 'object') {
            this.InputAddLookUpService.reverseAddressLookUp(this.value)
                .subscribe(
                    addressess => this.reverseAddress = addressess.results[0].formatted_address,
                    errors => this.alerts.push({ message: errors.statusText, status: 'danger' })
                );
        }
        this.onChange = fn;
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    setAddress(address: IAddressLookup): void {
        this.value = address.formatted_address;
        this.reverseAddress = this.value;
    }

    closeDropDown(): void {
        this.addresses = undefined;
    }
}
